import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const STREAM_CATEGORIES_KEY = ["stream-categories"];
const fetchStreamCategories = () => fetch("GET", qualifyUrl("/plugins/org.graylog.plugins.illuminate/stream_categories"));
const useStreamCategories = (enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: STREAM_CATEGORIES_KEY,
    queryFn: fetchStreamCategories,
    enabled
  });
  return {
    categories: data != null ? data : [],
    isLoading: isLoading && enabled
  };
};
export default useStreamCategories;
